import {
  ApiBlueprint,
  createFrontendPlugin,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiCalendar2Line } from '@remixicon/react';
import { rootRouteRef } from './routes';
import { CalendarClient } from './api/CalendarClient';
import { calendarApiRef } from './api/ref';

export const calendarApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: calendarApiRef,
      deps: {
        fetchApi: fetchApiRef,
      },
      factory: ({ fetchApi }) => new CalendarClient({ fetchApi }),
    }),
});

export const eventsPage = PageBlueprint.make({
  params: {
    path: '/community-calendar',
    routeRef: rootRouteRef,
    loader: () => import('./components/CalendarRouter').then(m => <m.CalendarRouter />),
  },
});

export default createFrontendPlugin({
  pluginId: 'community-calendar',
  title: 'Community Calendar',
  icon: <RiCalendar2Line />,
  extensions: [eventsPage, calendarApi],
  routes: {
    root: rootRouteRef,
  },
});
